import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Stack } from '@mui/material'
import React, { useState } from 'react'
import { updatePassword } from '../../../services/UserAccountService'

const UpdatePasswordModal = ({ open, onClose }) => {
    const [errors, setErrors] = useState({})
    const [responseMessage, setResponseMessage] = useState('')
    const [showResponseDialog, setShowResponseDialog] = useState(false)
    const [loading, setLoading] = useState(false)
    const [newEmployee, setNewEmployee] = useState({})

    // Handle opening and closing of register modal

    const validateFields = () => {
        const newErrors = {}
        const requiredFields = ['oldPassword', 'newPassword']

        requiredFields.forEach((field) => {
            if (!newEmployee[field]) {
                newErrors[field] = 'This field is required'
            }
        })

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleRegisterInputChange = (e) => {
        const { name, value } = e.target
        setNewEmployee((prev) => ({ ...prev, [name]: value }))
    }

    const handleFormSubmit = async (event) => {
        event.preventDefault()
        setLoading(true)

        if (validateFields()) {
            try {
                console.log('newEmployee', newEmployee)
                const result = await updatePassword(newEmployee)

                if (result.error) {
                    setResponseMessage(result.error)
                } else {
                    setResponseMessage(result.message)
                }
                setShowResponseDialog(true)
            } catch (error) {
                console.log('error', error)
                setResponseMessage('An error occurred while recording attendance.')
                setShowResponseDialog(true)
            } finally {
                setLoading(false)
                onClose()
            }
        }
    }

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle>Update Password</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleFormSubmit}>
                        <Stack spacing={2}>
                            {/* Form fields */}
                            <TextField
                                margin="normal"
                                name="oldPassword"
                                label="Old Password"
                                fullWidth
                                type="password"
                                variant="outlined"
                                value={newEmployee.oldPassword}
                                onChange={handleRegisterInputChange}
                                error={Boolean(errors.oldPassword)}
                                helperText={errors.oldPassword}
                            />

                            <TextField
                                margin="normal"
                                name="newPassword"
                                label="New Password"
                                fullWidth
                                variant="outlined"
                                value={newEmployee.newPassword}
                                type="password"
                                onChange={handleRegisterInputChange}
                                error={Boolean(errors.newPassword)}
                                helperText={errors.newPassword}
                            />
                        </Stack>

                        <DialogActions style={{ marginTop: '16px' }}>
                            <Button onClick={onClose} color="secondary">
                                Cancel
                            </Button>
                            <Button type="submit" color="primary" variant="contained">
                                Update
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>

            {/* Response Dialog */}
            <Dialog open={showResponseDialog} onClose={() => setShowResponseDialog(false)}>
                <DialogTitle>Response</DialogTitle>
                <DialogContent>
                    <p>{responseMessage}</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowResponseDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default UpdatePasswordModal
